import { render, staticRenderFns } from "./widgetGeneralStatus.vue?vue&type=template&id=74bb6d62&scoped=true&"
import script from "./widgetGeneralStatus.vue?vue&type=script&lang=js&"
export * from "./widgetGeneralStatus.vue?vue&type=script&lang=js&"
import style0 from "./widgetGeneralStatus.vue?vue&type=style&index=0&id=74bb6d62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bb6d62",
  null
  
)

export default component.exports